/* EMX SUPPLY — global.js */
(function () {
  'use strict';

  /* Click pulse animation on interactive elements */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('.btn, .product-card, .collection-tile, .tabs-nav__btn');
    if (!el) return;
    el.classList.remove('pulse');
    void el.offsetWidth; /* restart animation */
    el.classList.add('pulse');
    setTimeout(function () { el.classList.remove('pulse'); }, 550);
  });

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    document.addEventListener('DOMContentLoaded', function () {
      document.body.classList.add('reveal-on');
      var targets = document.querySelectorAll(
        '.section-pad, .value-prop, .product-card, .collection-tile, .review-card, .compare-table, .why-us__item'
      );
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('in-view');
            io.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      targets.forEach(function (t) {
        t.classList.add('reveal');
        io.observe(t);
      });
    });
  }

  /* Mobile nav toggle */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-site-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  /* Product gallery thumbnails */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-main-image]');
    main.src = thumb.dataset.src;
    main.srcset = '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* Variant picker */
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var jsonEl = wrapper.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var selects = wrapper.querySelectorAll('[data-option-select]');
    var idInput = wrapper.querySelector('[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    var btn = wrapper.querySelector('[data-add-button]');
    var moneyFormat = wrapper.dataset.moneyFormat || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function currentVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return product.variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function update() {
      var variant = currentVariant();
      if (!variant) {
        btn.textContent = 'Unavailable';
        btn.disabled = true;
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.style.display = '';
          compareEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (variant.available) {
        btn.disabled = false;
        btn.textContent = btn.dataset.labelAdd || 'Add to cart';
      } else {
        btn.disabled = true;
        btn.textContent = 'Sold out';
      }
      /* Swap image if variant has one */
      if (variant.featured_image) {
        var main = document.querySelector('[data-main-image]');
        if (main) { main.src = variant.featured_image.src; main.srcset = ''; }
      }
      /* Update URL */
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    if (selects.length) update();
  });

  /* AJAX add to cart */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Error'); });
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:added'));
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
        })
        .catch(function (err) {
          btn.textContent = err.message.slice(0, 40) || 'Error';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500);
        });
    });
  });

  /* Track order form: open universal carrier tracking */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-track-form]');
    if (!form) return;
    e.preventDefault();
    var num = (form.querySelector('[name="tracking"]').value || '').replace(/\s+/g, '');
    if (!num) return;
    window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener');
  });

  /* Cart page quantity auto-submit */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      input.closest('form').submit();
    });
  });

  /* Collection sort */
  var sortSelect = document.querySelector('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ============ v2 features ============ */

  /* Rotating announcement bar */
  function initAnnouncement(annc) {
    if (!annc) return;
    var slides = annc.querySelectorAll('.announcement-bar__slide');
    var idx = 0;
    if (annc._timer) clearInterval(annc._timer);
    function showSlide(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
    }
    function startAnnc() {
      clearInterval(annc._timer);
      if (slides.length > 1) annc._timer = setInterval(function () { showSlide(idx + 1); }, 4000);
    }
    if (!annc._bound) {
      annc._bound = true;
      annc.addEventListener('click', function (e) {
        if (e.target.closest('[data-announcement-prev]')) { showSlide(idx - 1); startAnnc(); }
        if (e.target.closest('[data-announcement-next]')) { showSlide(idx + 1); startAnnc(); }
      });
    }
    startAnnc();
  }
  initAnnouncement(document.querySelector('[data-announcement]'));

  /* Countdown banner — robust date parsing */
  function initCountdown(el) {
    var wrap = el.closest('[data-countdown-wrap]');
    var dateStr = (el.dataset.endDate || el.dataset.end || '').trim();
    var timeStr = (el.dataset.endTime || '23:59').trim();
    if (!dateStr) return;

    /* Prefer server-parsed epoch (store timezone), fall back to JS parsing */
    var end = NaN;
    var epoch = parseInt(el.dataset.epoch, 10);
    if (!isNaN(epoch) && epoch > 1000000000) {
      end = epoch * 1000;
    } else {
      var dt;
      if (dateStr.indexOf('T') !== -1) {
        dt = new Date(dateStr.replace(/-/g, '/').replace('T', ' '));
        if (isNaN(dt)) dt = new Date(dateStr);
      } else {
        dt = new Date(dateStr.replace(/-/g, '/'));
        if (isNaN(dt)) dt = new Date(dateStr);
        if (!isNaN(dt)) {
          var hm = timeStr.split(':');
          dt.setHours(parseInt(hm[0], 10) || 23, parseInt(hm[1], 10) || 59, 59, 0);
        }
      }
      if (!isNaN(dt)) end = dt.getTime();
    }
    if (isNaN(end)) { el.style.display = 'none'; return; }
    el.style.display = '';

    var d = el.querySelector('[data-cd-d]'), h = el.querySelector('[data-cd-h]'),
        m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { if (wrap) wrap.style.display = 'none'; clearInterval(el._iv); return; }
      d.textContent = pad(Math.floor(diff / 86400000));
      h.textContent = pad(Math.floor(diff / 3600000) % 24);
      m.textContent = pad(Math.floor(diff / 60000) % 60);
      s.textContent = pad(Math.floor(diff / 1000) % 60);
      /* urgency mode in the final hour */
      if (wrap) wrap.classList.toggle('is-urgent', diff < 3600000);
    }
    if (el._iv) clearInterval(el._iv);
    el._iv = setInterval(tick, 1000);
    tick();
  }
  document.querySelectorAll('[data-countdown]').forEach(initCountdown);

  /* Theme editor: re-init sections when Shopify re-renders them */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-countdown]').forEach(initCountdown);
    initAnnouncement(e.target.querySelector('[data-announcement]'));
    if (typeof initPopup === 'function') initPopup(e.target.querySelector('[data-popup]'));
  });

  /* Slider arrows for all horizontal scrollers (delegated) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-slide-prev], [data-slide-next]');
    if (!btn) return;
    var section = btn.closest('section') || document;
    /* prefer the visible tab panel's track if this section has tabs */
    var track = section.querySelector('.tabs-panel.is-active [data-slide-track]') || section.querySelector('[data-slide-track]');
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.offsetWidth + 18 : 320;
    track.scrollBy({ left: btn.hasAttribute('data-slide-prev') ? -step : step, behavior: 'smooth' });
  });

  /* Tabs (delegated) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tab-btn]');
    if (!btn) return;
    var tabs = btn.closest('[data-tabs]');
    if (!tabs) return;
    var i = btn.dataset.tabBtn;
    tabs.querySelectorAll('[data-tab-btn]').forEach(function (b) {
      var on = b.dataset.tabBtn === i;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    tabs.querySelectorAll('[data-tab-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.tabPanel === i);
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerOverlay = document.querySelector('[data-cart-overlay]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    drawerOverlay.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; drawerOverlay.hidden = true; }, 300);
  }
  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html || !drawer) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-drawer-inner]');
        var current = drawer.querySelector('[data-drawer-inner]');
        if (fresh && current) current.replaceWith(fresh);
      });
  }
  function refreshCartCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]') && drawer) {
      e.preventDefault();
      refreshDrawer().then(openDrawer);
    }
    if (e.target.closest('[data-cart-close]') || e.target === drawerOverlay) closeDrawer();
    var qtyBtn = e.target.closest('[data-drawer-qty]');
    if (qtyBtn) {
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(qtyBtn.dataset.line), quantity: Number(qtyBtn.dataset.qty) })
      }).then(function () { return Promise.all([refreshDrawer(), refreshCartCount()]); });
    }
  });

  /* Hook AJAX add-to-cart into drawer (overrides button feedback flow) */
  document.addEventListener('cart:added', function () {
    refreshCartCount();
    if (drawer) refreshDrawer().then(openDrawer);
  });

  /* ---------- Quick view ---------- */
  var qvOverlay = document.querySelector('[data-qv-overlay]');
  var qvContent = document.querySelector('[data-qv-content]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openQuickView(handle) {
    if (!qvOverlay) return;
    qvContent.innerHTML = '<p style="padding:40px;text-align:center">Loading…</p>';
    qvOverlay.hidden = false;
    document.body.style.overflow = 'hidden';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var img = p.featured_image ? '<img src="' + p.featured_image + '" alt="">' : '<div></div>';
        var optionsHtml = '';
        if (!(p.variants.length === 1 && p.variants[0].title === 'Default Title')) {
          p.options.forEach(function (opt, i) {
            optionsHtml += '<div class="option-group"><label>' + opt.name + '</label><select data-qv-opt="' + i + '">' +
              opt.values.map(function (v) { return '<option value="' + v.replace(/"/g, '&quot;') + '">' + v + '</option>'; }).join('') +
              '</select></div>';
          });
        }
        var compare = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
        qvContent.innerHTML =
          '<div class="qv-grid">' + img +
          '<div><h3 class="qv-title">' + p.title + '</h3>' +
          '<div class="qv-price"><span data-qv-price>' + money(p.price) + '</span> ' + compare + '</div>' +
          optionsHtml +
          '<button class="btn btn--full" data-qv-add data-handle="' + handle + '">Add to cart</button>' +
          '<a class="qv-link" href="' + p.url + '">View full details →</a></div></div>';
        qvContent.dataset.productJson = JSON.stringify(p);
      })
      .catch(function () {
        qvContent.innerHTML = '<p style="padding:40px;text-align:center">Could not load product.</p>';
      });
  }

  function qvCurrentVariant() {
    var p = JSON.parse(qvContent.dataset.productJson || '{}');
    if (!p.variants) return null;
    var sels = qvContent.querySelectorAll('[data-qv-opt]');
    if (!sels.length) return p.variants[0];
    var chosen = Array.prototype.map.call(sels, function (s) { return s.value; });
    return p.variants.find(function (v) {
      return chosen.every(function (val, i) { return v.options[i] === val; });
    });
  }

  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-quick-view]');
    if (qv) {
      e.preventDefault();
      e.stopPropagation();
      openQuickView(qv.dataset.handle);
      return;
    }
    if (e.target.closest('[data-qv-close]') || e.target === qvOverlay) {
      qvOverlay.hidden = true;
      document.body.style.overflow = '';
    }
    var addBtn = e.target.closest('[data-qv-add]');
    if (addBtn) {
      var variant = qvCurrentVariant();
      if (!variant) { addBtn.textContent = 'Unavailable'; return; }
      if (!variant.available) { addBtn.textContent = 'Sold out'; return; }
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error();
        qvOverlay.hidden = true;
        document.body.style.overflow = '';
        document.dispatchEvent(new CustomEvent('cart:added'));
      }).catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Error — try again';
      });
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-qv-opt]')) {
      var v = qvCurrentVariant();
      var priceEl = qvContent.querySelector('[data-qv-price]');
      var btn = qvContent.querySelector('[data-qv-add]');
      if (v && priceEl) priceEl.textContent = money(v.price);
      if (btn) {
        btn.disabled = v ? !v.available : true;
        btn.textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
      }
    }
  });

  /* ---------- Email popup ---------- */
  function initPopup(popup) {
    if (!popup) return;
    var key = 'popup:' + popup.dataset.popupId;
    var posted = popup.querySelector('.form-status--ok');
    var designMode = window.Shopify && window.Shopify.designMode;
    var suppressed = false;
    try { suppressed = Date.now() < Number(localStorage.getItem(key) || 0); } catch (err) {}

    function openPopup() { popup.hidden = false; document.body.style.overflow = 'hidden'; }
    function closePopup() {
      popup.hidden = true;
      document.body.style.overflow = '';
      if (!designMode) {
        try { localStorage.setItem(key, String(Date.now() + 7 * 86400000)); } catch (err) {}
      }
    }
    popup._open = openPopup;

    if (!popup._bound) {
      popup._bound = true;
      popup.addEventListener('click', function (e) {
        if (e.target.closest('[data-popup-close]') || e.target === popup) closePopup();
      });
    }

    if (posted) {
      openPopup(); /* show success state after signup redirect */
    } else if (designMode) {
      /* In the theme editor: show shortly after load so the merchant can see it */
      setTimeout(openPopup, 1500);
    } else if (!suppressed) {
      setTimeout(openPopup, Number(popup.dataset.popupDelay || 5) * 1000);
    }
  }
  initPopup(document.querySelector('[data-popup]'));

  /* Theme editor: open popup when its section is selected, re-init on re-render */
  document.addEventListener('shopify:section:select', function (e) {
    var p = e.target.querySelector('[data-popup]');
    if (p && p._open) p._open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var p = e.target.querySelector('[data-popup]');
    if (p) { p.hidden = true; document.body.style.overflow = ''; }
  });

  /* ---------- Search overlay + predictive search ---------- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  if (searchOverlay) {
    var searchInput = searchOverlay.querySelector('[data-search-input]');
    var resultsEl = searchOverlay.querySelector('[data-search-results]');
    var debounce;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-toggle]')) {
        searchOverlay.hidden = false;
        document.body.style.overflow = 'hidden';
        setTimeout(function () { searchInput.focus(); }, 50);
      }
      if (e.target.closest('[data-search-close]') || e.target === searchOverlay) {
        searchOverlay.hidden = true;
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!searchOverlay.hidden) { searchOverlay.hidden = true; document.body.style.overflow = ''; }
        if (qvOverlay && !qvOverlay.hidden) { qvOverlay.hidden = true; document.body.style.overflow = ''; }
        closeDrawer();
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(debounce);
        var q = searchInput.value.trim();
        if (q.length < 2) { resultsEl.innerHTML = ''; return; }
        debounce = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (((data.resources || {}).results || {}).products) || [];
              if (!products.length) {
                resultsEl.innerHTML = '<p style="padding:14px; color:var(--c-cream-dim)">No matches for “' + q.replace(/</g, '&lt;') + '”</p>';
                return;
              }
              resultsEl.innerHTML = products.map(function (p) {
                var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
                if (imgUrl) imgUrl += (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=120';
                var img = imgUrl ? '<img src="' + imgUrl + '" alt="">' : '<span></span>';
                return '<a class="search-result" href="' + p.url + '">' + img +
                  '<span>' + p.title + '</span><strong>' + p.price + '</strong></a>';
              }).join('') +
              '<a class="search-result__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results →</a>';
            });
        }, 250);
      });
    }
  }
})();
